import React from "react";
import "../../scss/components/transactions/_transaction_status_indicator.scss";

function FailureStatusIndicator(props) {
  return (
    <div className={`step step-hover error`} data-tip={props.tooltipText}>
      <div className="step-indicator">
        <hr />
        <div className="circle error"></div>
        <hr />
      </div>
    </div>
  );
}

export default FailureStatusIndicator;
